<template>
  <div>
    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Situação" prop="ativo" :rules="[$requiredChange]" key="ativo">
              <el-select v-model="dados.ativo">
                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                <el-option :key="false" label="INATIVO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Perecível" prop="perecivel" :rules="[$requiredChange]" key="perecivel">
              <el-select v-model="dados.perecivel">
                <el-option :key="true" label="SIM" :value="true"></el-option>
                <el-option :key="false" label="NÃO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Categoria" prop="categoria_id" key="categoria_id">
              <el-select v-model="dados.categoria_id" filterable clearable placeholder="Selecione a categoria" style="width: 100%;">
                <el-option v-for="c in categorias" :key="c.id" :label="c.nome" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Tipo de Alimento" prop="tipo_alimento_id" key="tipo_alimento_id">
              <el-select v-model="dados.tipo_alimento_id" filterable clearable placeholder="Selecione o tipo de alimento" style="width: 100%;">
                <el-option v-for="t in tiposAlimento" :key="t.id" :label="t.nome" :value="t.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="18" :md="18">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatUpper('nome')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Unidade medida" prop="unidade_medida_id" key="unidade_medida_id">
              <el-select v-model="dados.unidade_medida_id" placeholder="Selecione" filterable style="width: 100%;"
                         @change="sincronizarUnidadeTexto">
                <el-option v-for="u in unidadesCadastradas" :key="u.id"
                           :label="u.sigla + ' — ' + u.nome" :value="u.id"></el-option>
              </el-select>
              <div class="u-fs-12 u-mt-5" v-if="!dados.unidade_medida_id && dados.unidade_medida">
                Registro anterior: <strong>{{ dados.unidade_medida }}</strong> — selecione a unidade correspondente.
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Validade (dias)" prop="validade_dias" key="validade_dias">
              <el-input v-model="dados.validade_dias" maxlength="6"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Tabela de origem" prop="tabela_ingrediente_id" key="tabela_ingrediente_id">
              <el-select v-model="dados.tabela_ingrediente_id" clearable filterable style="width:100%"
                         :disabled="origemOficial" placeholder="Próprio do município">
                <el-option v-for="t in tabelas" :key="t.id"
                           :label="t.nome + (t.padrao ? ' (oficial)' : '')" :value="t.id"></el-option>
              </el-select>
              <!--
                `tabela_ingrediente_id` é a coluna nova; `fonte_dados` é o texto antigo, e é
                dele que a LISTAGEM tira a coluna "Tabela de origem" (accessor
                `origem_exibicao`, que cai no `fonte_dados` quando não há FK). Sem esta linha
                a listagem dizia "TACO" e a edição mostrava o placeholder "Próprio do
                município" — a tela contradizia a lista e parecia ter perdido o dado.
              -->
              <div class="u-fs-12 u-mt-5" v-if="origemLegada">
                Origem registrada: <strong>{{ dados.fonte_dados }}</strong> (cadastro anterior à
                tabela de origem). Valores nutricionais são somente leitura.
              </div>
              <div class="u-fs-12 u-mt-5" v-else-if="origemOficial">
                Ingrediente de tabela oficial: origem e valores nutricionais são somente leitura.
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-collapse v-model="collapseAtivo">
          <el-collapse-item title="Informação Nutricional (por 100g)" name="nutricional">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Energia (kcal)" prop="kcal_100g" key="kcal_100g">
                  <el-input v-model="dados.kcal_100g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Carboidratos (g)" prop="carboidrato_g" key="carboidrato_g">
                  <el-input v-model="dados.carboidrato_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Proteínas (g)" prop="proteina_g" key="proteina_g">
                  <el-input v-model="dados.proteina_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Lipídios (g)" prop="lipidio_g" key="lipidio_g">
                  <el-input v-model="dados.lipidio_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Fibras (g)" prop="fibra_g" key="fibra_g">
                  <el-input v-model="dados.fibra_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Sódio (mg)" prop="sodio_mg" key="sodio_mg">
                  <el-input v-model="dados.sodio_mg" maxlength="12"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Açúcar adicionado (g)" prop="acucar_adicionado_g" key="acucar_adicionado_g">
                  <el-input v-model="dados.acucar_adicionado_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Gordura saturada (g)" prop="gordura_saturada_g" key="gordura_saturada_g">
                  <el-input v-model="dados.gordura_saturada_g" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Custo" prop="custo" key="custo">
                  <el-input v-model="dados.custo" maxlength="20" placeholder="Ex.: 5,90"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item name="nutrientes" v-if="edit">
            <template slot="title">
              Outros nutrientes&nbsp;<small>(item 38 — cadastráveis pela rede)</small>
            </template>

            <el-alert v-if="origemOficial" class="u-mb-10" type="warning" :closable="false" show-icon
              title="Ingrediente de tabela oficial: os valores vêm da publicação e não são editados aqui."></el-alert>

            <el-row :gutter="10" class="u-mb-10" v-if="!origemOficial">
              <el-col :xs="24" :sm="10">
                <el-select v-model="novoNutriente.nutriente_id" placeholder="Nutriente" filterable style="width:100%">
                  <el-option v-for="n in nutrientesDisponiveis" :key="n.id"
                             :label="n.nome + ' (' + n.unidade + ')'" :value="n.id"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-input v-model="novoNutriente.valor_100g" type="number" step="0.0001"
                          placeholder="Valor por 100 g — deixe vazio se a fonte não informa"></el-input>
              </el-col>
              <el-col :xs="24" :sm="6">
                <el-button type="primary" @click="salvarNutriente" :disabled="!novoNutriente.nutriente_id" style="width:100%">GRAVAR</el-button>
              </el-col>
            </el-row>

            <div class="u-fs-12 u-mb-10">
              Campo vazio grava <strong>“não informado”</strong>, e não zero — são coisas diferentes no cálculo da receita.
            </div>

            <table class="table table-striped" v-if="nutricional && nutricional.cadastraveis && nutricional.cadastraveis.length">
              <thead>
                <tr>
                  <th>Nutriente</th>
                  <th style="width: 160px;" class="u-text-right">Por 100 g</th>
                  <th style="width: 90px;" class="u-text-center" v-if="!origemOficial">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="n in nutricional.cadastraveis" :key="n.nutriente_id">
                  <td>{{ n.nome }}<span v-if="n.sigla"> ({{ n.sigla }})</span></td>
                  <td class="u-text-right">
                    <span v-if="n.valor !== null">{{ n.valor }} {{ n.unidade }}</span>
                    <em v-else class="u-fs-12">não informado</em>
                  </td>
                  <td class="u-text-center" v-if="!origemOficial">
                    <el-button @click="removerNutriente(n.nutriente_id)" title="Remover" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-else class="u-fs-12">Nenhum nutriente adicional registrado para este ingrediente.</div>
          </el-collapse-item>

        </el-collapse>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-alimento" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    collapseAtivo: [],
    categorias: [],
    tiposAlimento: [],
    unidadesCadastradas: [],
    tabelas: [],
    nutrientesDisponiveis: [],
    nutricional: null,
    novoNutriente: { nutriente_id: '', valor_100g: '' },
    dados: {
      id: '',
      nome: '',
      categoria_id: '',
      tipo_alimento_id: '',
      unidade_medida: '',
      perecivel: false,
      validade_dias: '',
      ativo: true,
      kcal_100g: '',
      carboidrato_g: '',
      proteina_g: '',
      lipidio_g: '',
      fibra_g: '',
      sodio_mg: '',
      acucar_adicionado_g: '',
      gordura_saturada_g: '',
      custo: '',
      fonte_dados: '',
      unidade_medida_id: '',
      tabela_ingrediente_id: ''
    }
  }),
  mounted () {
    this.loadCategorias()
    this.loadTiposAlimento()
    this.loadUnidades()
    this.loadTabelas()
    this.loadNutrientes()
  },
  computed: {
    /*
     * Reflete o backend, que é quem decide: tabela oficial não aceita edição de valor.
     *
     * `MerendaCatalogoService::ehDeTabelaOficial()` considera DUAS marcas — a FK nova e,
     * na ausência dela, o texto legado em `fonte_dados`. Aqui só a FK era olhada, então
     * os 177 ingredientes vindos da TACO (que têm `fonte_dados` e nenhuma FK) apareciam
     * como editáveis: o formulário oferecia o cadastro de "Outros nutrientes" e o backend
     * recusava a gravação com "Ingrediente de tabela oficial não aceita edição de valor".
     */
    origemOficial () {
      if (this.dados.tabela_ingrediente_id) {
        const t = this.tabelas.find(x => x.id === this.dados.tabela_ingrediente_id)
        return !!(t && t.padrao)
      }
      return !!this.dados.fonte_dados
    },
    /* Origem só pelo campo legado: não há FK, mas o registro veio de tabela oficial. */
    origemLegada () {
      return !this.dados.tabela_ingrediente_id && !!this.dados.fonte_dados
    }
  },
  methods: {
    loadUnidades () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/getAll`, this.$store.getters.getHeaderAuth)
        .then(response => { this.unidadesCadastradas = response.data || [] })
        .catch(() => { this.unidadesCadastradas = [] })
    },
    loadTabelas () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/tabela-ingrediente/getAll`, this.$store.getters.getHeaderAuth)
        .then(response => { this.tabelas = response.data || [] })
        .catch(() => { this.tabelas = [] })
    },
    loadNutrientes () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/nutriente/getAll`, this.$store.getters.getHeaderAuth)
        .then(response => { this.nutrientesDisponiveis = response.data || [] })
        .catch(() => { this.nutrientesDisponiveis = [] })
    },
    /* Mantém o texto legado coerente com a seleção; a coluna histórica nunca é apagada. */
    sincronizarUnidadeTexto (id) {
      const u = this.unidadesCadastradas.find(x => x.id === id)
      if (u) this.dados.unidade_medida = u.sigla
    },
    carregarNutricional () {
      if (!this.dados.id) return
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/${this.dados.id}/nutrientes`, this.$store.getters.getHeaderAuth)
        .then(response => { this.nutricional = response.data })
        .catch(() => { this.nutricional = null })
    },
    salvarNutriente () {
      window.eventBus.$emit('loading', true)
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/${this.dados.id}/nutriente-salvar`, this.novoNutriente, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          this.nutricional = response.data
          this.novoNutriente = { nutriente_id: '', valor_100g: '' }
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    removerNutriente (nutrienteId) {
      window.eventBus.$emit('loading', true)
      this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/${this.dados.id}/nutriente-remover/${nutrienteId}`, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          this.nutricional = response.data
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    loadCategorias () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/categoria/getAll`, { ativo: true }, this.$store.getters.getHeaderAuth)
        .then(response => { this.categorias = response.data || [] })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    loadTiposAlimento () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/tipo-alimento/getAll`, { ativo: true }, this.$store.getters.getHeaderAuth)
        .then(response => { this.tiposAlimento = response.data || [] })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    getById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.dados = JSON.parse(JSON.stringify(response.data))
          this.carregarNutricional()
        })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    onSubmit () {
      document.getElementById("btn-alimento").focus()
      this.$refs.dados.validate((valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        const url = this.edit
          ? `${this.$store.state.config.baseUrlApi}/api/merenda/alimento/update/${this.dados.id}`
          : `${this.$store.state.config.baseUrlApi}/api/merenda/alimento/store`
        this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
          .then(response => {
            window.eventBus.$emit('loading', false)
            if (response.data && response.data.erro) {
              const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar.')
              return window.eventBus.$emit('alert', { msg, type: 'warning' })
            }
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.$emit('onSubmitAlimento')
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
      })
    },
    formatUpper (field) {
      if (!this.dados[field]) return
      this.dados[field] = this.$removerAcentos(String(this.dados[field]).toUpperCase())
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getById(value)
          this.edit = true
        }
      }
    }
  }
}
</script>
